import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, switchMap } from 'rxjs/operators';
import { combineLatest, Observable, of } from 'rxjs';
import _ from 'lodash';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';

@Pipe({
   name: 'isUserActionExecutable$',
})
export class IsUserActionExecutablePipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(brickInstanceId: string, toolbarId: string, actionId: string): Observable<boolean> {
      return combineLatest([
         this.store.select(ToolbarSettingsState.getActionTypeForUserActionFn).pipe(map((fn) => fn(brickInstanceId, toolbarId, actionId))),
         this.store.select(ToolbarSettingsState.getActionSettingFn).pipe(map((fn) => fn(brickInstanceId, toolbarId, actionId))),
      ]).pipe(
         switchMap(([actionType, actionSettings]) => {
            if (_.isNil(actionType)) {
               return of(false);
            }
            return actionType.isActionExecutable$(this.store, actionSettings as any);
         })
      );
   }
}
